var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('v-img',{class:_vm.colorImage(hover),attrs:{"contain":"","src":_vm.src,"aspect-ratio":"1"}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }